import ProductIcon from '@mui/icons-material/Collections';
import { useTranslate } from 'react-admin';

import CardWithIcon from './CardWithIcon';

interface Props {
    value?: string;
}

const VerificationEffectivenessActionPending = (props: Props) => {
    const { value } = props;
    const translate = useTranslate();
    return (
        <CardWithIcon
            to='/verificationEffectivenessAction?filter={"sendToResponsibleForVerificationEffectivenessAction":true,"verificationDate":null}'
            icon={ProductIcon}
            title={translate('resources.dashboard.verificationEffectivenessActionPending')}
            subtitle={value}
        />
    );
};

export default VerificationEffectivenessActionPending;